import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';

import APIError from 'types/api_error';
import {
  Deployment,
  DeploymentConfiguration,
  DeploymentState,
} from 'types/deployment';

import { useAPI } from 'hooks/api/useAPI';

type UseCreateDeploymentParams = {
  pipeline_id: string;
  gateway_id: string | null;
  name?: string | null;
  state: DeploymentState | null;
  configuration: DeploymentConfiguration;
};

export function useCreateDeployment({
  onSettled,
  ...options
}: UseMutationOptions<Deployment, APIError, UseCreateDeploymentParams> = {}) {
  const queryClient = useQueryClient();
  const { client, applicationID } = useAPI();

  return useMutation({
    mutationFn: async (params) => {
      const { data } = await client.post(
        `/apps/${applicationID}/deployments`,
        params
      );

      return data;
    },
    ...options,
    onSettled(...args) {
      onSettled?.(...args);
      queryClient.invalidateQueries(['deployments']);
    },
  });
}
